// Module
var code = "<matrix-groups></matrix-groups>\n";
// Exports
module.exports = code;